var _defs, _rect, _circle, _circle2, _text, _text2, _text3, _text4, _g, _g2, _rect2, _rect3, _rect4, _circle3, _text5, _text6, _text7, _line, _rect5, _text8, _text9, _rect6, _text10, _rect7, _text11, _text12, _rect8, _circle4, _path, _text13, _rect9, _rect10, _rect11, _text14, _circle5, _path2, _rect12, _text15, _circle6, _circle7, _text16, _text17, _text18, _text19, _rect13, _text20, _text21, _text22, _path3, _g3, _rect14, _text23, _text24, _polyline, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvanaAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    width: 1280,
    height: 720,
    fontFamily: "'Segoe UI','Helvetica Neue',Arial,sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ebg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1a3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a78bfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2dd4bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screen",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eglow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a78bfa",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a78bfa",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#ebg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 360,
    r: 300,
    fill: "url(#eglow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 150,
    r: 220,
    fill: "url(#eglow)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 104,
    fill: "#ffffff",
    fontSize: 46,
    fontWeight: 800,
    letterSpacing: -1
  }, "Evana")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 136,
    fill: "#a78bfa",
    fontSize: 18,
    fontWeight: 600
  }, "AI Life Coach App")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 172,
    fill: "#93a4c4",
    fontSize: 14.5
  }, "Conversation-first coaching for goals,")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 192,
    fill: "#93a4c4",
    fontSize: 14.5
  }, "habits &amp; daily self-reflection.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 222,
    width: 300,
    height: 46,
    rx: 23,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 245,
    r: 7,
    fill: "#a78bfa"
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 250,
    fill: "#dbe4f5",
    fontSize: 14.5,
    fontWeight: 600
  }, "AI Coaching Chat"), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 280,
    width: 300,
    height: 46,
    rx: 23,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 303,
    r: 7,
    fill: "#2dd4bf"
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 308,
    fill: "#dbe4f5",
    fontSize: 14.5,
    fontWeight: 600
  }, "Smart Goals &amp; Habits"), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 338,
    width: 300,
    height: 46,
    rx: 23,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 361,
    r: 7,
    fill: "#f0a5d0"
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 366,
    fill: "#dbe4f5",
    fontSize: 14.5,
    fontWeight: 600
  }, "Guided Reflections"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 432,
    width: 120,
    height: 32,
    rx: 16,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#a78bfa",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 452,
    fill: "#c9b8ff",
    textAnchor: "middle"
  }, "React Native"), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 432,
    width: 66,
    height: 32,
    rx: 16,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#a78bfa",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("text", {
    x: 253,
    y: 452,
    fill: "#c9b8ff",
    textAnchor: "middle"
  }, "Expo"), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 432,
    width: 86,
    height: 32,
    rx: 16,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#a78bfa",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("text", {
    x: 337,
    y: 452,
    fill: "#c9b8ff",
    textAnchor: "middle"
  }, "FastAPI"), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 474,
    width: 98,
    height: 32,
    rx: 16,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#2dd4bf",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("text", {
    x: 141,
    y: 494,
    fill: "#9af0e2",
    textAnchor: "middle"
  }, "Supabase"), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 474,
    width: 98,
    height: 32,
    rx: 16,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#2dd4bf",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("text", {
    x: 247,
    y: 494,
    fill: "#9af0e2",
    textAnchor: "middle"
  }, "Groq LLM"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 96,
    width: 300,
    height: 584,
    rx: 44,
    fill: "#0a1024",
    stroke: "#322a5c",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 497,
    y: 112,
    width: 276,
    height: 552,
    rx: 34,
    fill: "url(#screen)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 126,
    width: 70,
    height: 8,
    rx: 4,
    fill: "#2a2450"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 527,
    cy: 164,
    r: 17,
    fill: "url(#brand)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 527,
    y: 169,
    fill: "#0a1024",
    fontSize: 15,
    fontWeight: 800,
    textAnchor: "middle"
  }, "E")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 553,
    y: 159,
    fill: "#ffffff",
    fontSize: 14.5,
    fontWeight: 700
  }, "Evana")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 553,
    y: 176,
    fill: "#6fe0c8",
    fontSize: 11.5
  }, "AI Coach \xB7 online")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 497,
    y1: 192,
    x2: 773,
    y2: 192,
    stroke: "#ffffff",
    strokeOpacity: 0.06
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 513,
    y: 206,
    width: 196,
    height: 58,
    rx: 16,
    fill: "#241b40"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 527,
    y: 230,
    fill: "#cdd6ec",
    fontSize: 11.5
  }, "Morning! Ready to plan your")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 527,
    y: 248,
    fill: "#cdd6ec",
    fontSize: 11.5
  }, "fitness goal for today?")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 276,
    width: 186,
    height: 40,
    rx: 16,
    fill: "#7c5cf0"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 591,
    y: 301,
    fill: "#ffffff",
    fontSize: 11.5
  }, "Yes, let's set it up")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 513,
    y: 328,
    width: 210,
    height: 58,
    rx: 16,
    fill: "#241b40"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 527,
    y: 352,
    fill: "#cdd6ec",
    fontSize: 11.5
  }, "Done! New goal created:")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 527,
    y: 370,
    fill: "#8fe6d5",
    fontSize: 11.5,
    fontWeight: 600
  }, "Run 3x / week \xB7 30 days")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 513,
    y: 400,
    width: 246,
    height: 60,
    rx: 14,
    fill: "#13233f",
    stroke: "#2a7f6d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 539,
    cy: 430,
    r: 13,
    fill: "#1f6f52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533 430 l4 5 l8 -9",
    stroke: "#7ff0c0",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 424,
    fill: "#eaf2ff",
    fontSize: 12,
    fontWeight: 600
  }, "Goal added \xB7 Fitness")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 562,
    y: 436,
    width: 176,
    height: 7,
    rx: 3.5,
    fill: "#20304d"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 562,
    y: 436,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "url(#brand)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 612,
    width: 228,
    height: 40,
    rx: 20,
    fill: "#1a1533",
    stroke: "#322a5c"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 524,
    y: 637,
    fill: "#6b7fa0",
    fontSize: 12
  }, "Message Evana\u2026")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 632,
    r: 18,
    fill: "url(#brand)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M743 632 h13 M750 626 l7 6 l-7 6",
    stroke: "#0a1024",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 118,
    width: 356,
    height: 176,
    rx: 20,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.12
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 854,
    y: 152,
    fill: "#93a4c4",
    fontSize: 12,
    letterSpacing: 1.5
  }, "GOAL PROGRESS")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 222,
    r: 42,
    fill: "none",
    stroke: "#2a2450",
    strokeWidth: 10
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 222,
    r: 42,
    fill: "none",
    stroke: "url(#brand)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "179 264",
    transform: "rotate(-90 906 222)"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 906,
    y: 229,
    fill: "#ffffff",
    fontSize: 20,
    fontWeight: 700,
    textAnchor: "middle"
  }, "68%")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 972,
    y: 214,
    fill: "#ffffff",
    fontSize: 16,
    fontWeight: 600
  }, "Fitness Journey")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 972,
    y: 238,
    fill: "#93a4c4",
    fontSize: 13
  }, "Target \xB7 30 days")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 972,
    y: 262,
    fill: "#8fe6d5",
    fontSize: 13,
    fontWeight: 600
  }, "On track")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 310,
    width: 356,
    height: 150,
    rx: 20,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.12
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 854,
    y: 344,
    fill: "#93a4c4",
    fontSize: 12,
    letterSpacing: 1.5
  }, "HABIT STREAK")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 854,
    y: 392,
    fill: "#ffffff",
    fontSize: 34,
    fontWeight: 800
  }, "12")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 906,
    y: 392,
    fill: "#a78bfa",
    fontSize: 15,
    fontWeight: 600
  }, "day streak")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1150 342 q10 12 0 22 q-8 8 -14 0 q-2 -8 6 -12 q-4 10 4 12 q8 -2 4 -14 z",
    fill: "#f6a94b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 416,
    width: 34,
    height: 22,
    rx: 6,
    fill: "url(#brand)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 416,
    width: 34,
    height: 22,
    rx: 6,
    fill: "url(#brand)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938,
    y: 416,
    width: 34,
    height: 22,
    rx: 6,
    fill: "url(#brand)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 416,
    width: 34,
    height: 22,
    rx: 6,
    fill: "url(#brand)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022,
    y: 416,
    width: 34,
    height: 22,
    rx: 6,
    fill: "url(#brand)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1064,
    y: 416,
    width: 34,
    height: 22,
    rx: 6,
    fill: "#2a2450"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1106,
    y: 416,
    width: 34,
    height: 22,
    rx: 6,
    fill: "#2a2450"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 476,
    width: 356,
    height: 150,
    rx: 20,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.12
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 854,
    y: 510,
    fill: "#93a4c4",
    fontSize: 12,
    letterSpacing: 1.5
  }, "MOOD THIS WEEK")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1100,
    y: 510,
    fill: "#6fe0c8",
    fontSize: 14,
    fontWeight: 700
  }, "+18% \u2191")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "858,588 906,570 954,578 1002,548 1050,556 1098,524 1146,532",
    fill: "none",
    stroke: "url(#brand)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#2dd4bf"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 588,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 570,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 578,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1002,
    cy: 548,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 556,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1098,
    cy: 524,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1146,
    cy: 532,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvanaAi);
export default __webpack_public_path__ + "static/media/evana-ai.bd5d2da42bebcec79a191dae0f90e84a.svg";
export { ForwardRef as ReactComponent };